export const blockedAccounts: string[] = [];

export const demoAccounts: string[] = [
  '29c00243-4d95-40a0-a6ba-505e42583135',
  '25ab4908-ff38-46ed-8c41-393ba97ef48a',
];

export const isAccountBlockedFromSavingData = (accountId: string = '') =>
  blockedAccounts.includes(accountId);
